// extracted by mini-css-extract-plugin
export default {"newsletter":"Newsletter_newsletter__NJWKg","newsletterHeader":"Newsletter_newsletterHeader__rp3WX","headerButton":"Newsletter_headerButton__mCRsX"};